// eslint-disable-next-line import/prefer-default-export
export enum Status {
  INACTIVE,
  FAIR,
  HEALTHY,
}
